<template>
  <div class="card-block">
    <div class="form-group row">
      <div class="col-md-10">
        <h5>
          <strong><i class="fas fa-landmark"></i> Resumo Operações Financeiras</strong>
        </h5>
      </div>
      <div class="col-md-2">
        <a v-if="!isBusyInfosFinance" href="javascript:void(0);" @click="isBusyInfosFinance = !isBusyInfosFinance">
          <i class="fas fa-eye-slash" style="font-size: 16px" v-b-tooltip.hover :title="'Minimizar Dados'"></i>
        </a>
        <a v-else href="javascript:void(0);" @click="onLoadFinanceResume">
          <i class="fas fa-eye" style="font-size: 16px" v-b-tooltip.hover :title="'Mostrar Dados'"></i>
        </a>
      </div>
    </div>
    <div v-if="!isBusyInfosFinance">
      <div class="associate__info__rows__container">
        <div class="d-flex justify-content-end">
          <b-button v-b-toggle.collapse-1 class="btn btn-third btn-sm">Filtrar <i class="fas fa-filter"></i></b-button>
        </div>
        <b-collapse id="collapse-1" class="mt-2">
          <div class="card shadow-sm p-3">
            <br />
            <label>Modalidade Produto</label>
            <v-select
              :options="productOptions"
              label="text"
              class="w-100"
              v-model="productSelected"
              placeholder="Selecione uma Modalidade Produto"
            ></v-select>
            <br />
            <label>Modalidade Bacen</label>
            <v-select
              :options="bacenOptions"
              taggable
              label="text"
              class="w-100"
              v-model="bacenSelected"
              placeholder="Selecione uma Modalidade Bacen"
            ></v-select>
            <br />
            <label>Modalidade Sub Bacen</label>
            <v-select
              :options="subBacenOptions"
              taggable
              label="text"
              class="w-100"
              v-model="subBacenSelected"
              placeholder="Selecione uma Modalidade Sub Bacen"
            ></v-select>
            <br />
          </div>
        </b-collapse>

                  <b-collapse id="collapse-1" class="mt-2">
            <div class="card shadow-sm p-3">
              <br />
              <label>Modalidade Produto</label>
              <v-select
                :options="productOptions"
                label="text"
                class="w-100"
                v-model="productSelected"
                placeholder="Selecione uma Modalidade Produto"
              ></v-select>
              <br />
              <label>Modalidade Bacen</label>
              <v-select
                :options="bacenOptions"
                taggable
                label="text"
                class="w-100"
                v-model="bacenSelected"
                placeholder="Selecione uma Modalidade Bacen"
              ></v-select>
              <br />
              <label>Modalidade Sub Bacen</label>
              <v-select
                :options="subBacenOptions"
                taggable
                label="text"
                class="w-100"
                v-model="subBacenSelected"
                placeholder="Selecione uma Modalidade Sub Bacen"
              ></v-select>
              <br />
            </div>
          </b-collapse>

        <div v-if="financeResume.cobrancaProducts.length">
          <b-card class="shadow-sm" no-body>
            <b-tabs class="tabsScroll" pills>
              <b-tab
                  v-for="(c, index) in financeResume.cobrancaProducts.filter(p => p.contratos || p.produtoDTO.nome !== 'TÍTULOS DESCONTADOS')"
                  :key="index"
                >
                <template slot="title">{{ index + 1 }}ª</template>
                <div class="associate__info__rows__group">
                  <h3 class="associate__info__rows__group__title">Cobrança</h3>
                  <div class="position-tag">
                    <span v-if="productSelected" class="tag" style="font-size: 10px;">
                      {{ productSelected }}
                      <button class="remove-button" @click="productSelected = null">&times;</button>
                    </span>
                    <span v-if="bacenSelected" class="tag" style="font-size: 10px;">
                      {{ bacenSelected }}
                      <button class="remove-button" @click="bacenSelected = null">&times;</button>
                    </span>
                    <span v-if="subBacenSelected" class="tag" style="font-size: 10px;">
                      {{ subBacenSelected }}
                      <button class="remove-button" @click="subBacenSelected = null">&times;</button>
                    </span>
                  </div>

                    <div v-if="c.produtoDTO && c.produtoDTO.nome !== 'TÍTULOS DESCONTADOS'">
                      <div class="row__container">
                      <p class="row__type">Produto</p>
                        <p class="row__description">{{ c.produtoDTO && c.produtoDTO.nome ? c.produtoDTO.nome.toLowerCase() : '-' }}</p>
                    </div>
                    <div class="row__container">
                      <p class="row__type">Operação</p>
                      <p class="row__description">{{ c.operacao ? c.operacao : '-' }}</p>
                    </div>
                    <div class="row__container">
                      <p class="row__type">Dias Em Atraso</p>
                      <p class="row__description">{{ c.diasAtraso ? c.diasAtraso : '-' }}</p>
                    </div>
                    <div class="row__container">
                      <p class="row__type">Valor</p>
                      <p class="row__description">{{ c.valor || c.valor === 0 ? onFormatMoney(c.valor) : '-' }}</p>
                    </div>
                  </div>
                  <div v-if="c.produtoDTO.nome === 'TÍTULOS DESCONTADOS'">
                    <div class="row__container">
                      <p class="row__type">Produtos</p>
                      <p class="row__description">{{ c.modalidadeBacen ? c.modalidadeBacen.toLowerCase() : '-' }}</p>
                    </div>
                      <div class="row__container">
                        <p class="row__type">Operações</p>
                        <p class="row__description">
                          <span v-if="c.contratos">
                            <i
                              class="fas fa-info-circle"
                              v-b-tooltip.hover
                              :title="'Operação: ' + c.contratos.join(', ')"
                              @click="$emit('scrollToContratosVigentes')"
                            ></i>
                            <button
                              class="btn btn-link p-0 ml-2"
                              style="font-size: 14px; text-decoration: underline; color: #04a791;"
                              @click="$emit('scrollToContratosVigentes')"
                            >
                              VER MAIS
                            </button>
                          </span>
                          <span v-else>{{ c.operacao ? c.operacao : '-' }}</span>
                        </p>
                      </div>
                    <div class="row__container">
                      <p class="row__type">Valor Total</p>
                      <p class="row__description">{{ c.valorContrato || c.valorContrato === 0 ? onFormatMoney(c.valorContrato) : '-' }}</p>
                    </div>
                  </div>
                  <DefaultButton
                    btnVariant="btn-third justify-content-center"
                    :onClick="() => openCard(c.cardDTO.id)"
                    text="Ver Card"
                  />
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>

        <div v-if="financeResume.contracts.length">
          <b-card class="mt-2 shadow-sm" no-body>
            <b-tabs pills class="tabsScroll" content-class="mt-3">
              <b-tab v-for="(c, index) in financeResume.contracts" :key="index">
                <template slot="title">
                  <span class="mr-auto">{{ index + 1 }}º</span>
                </template>
                <div class="associate__info__rows__group">
                  <div class="d-flex justify-content-between align-items-center">
                    <h3 class="associate__info__rows__group__title">Contratos Vigentes</h3>
                    <div>
                      <b-button v-b-toggle.collapse-1 class="btn btn-third btn-sm" @click="handleShowVigentes" v-if="maiorQueDezContratos">
                        Ver mais
                      </b-button>
                    </div>
                  </div>
                  <div class="position-tag">
                    <span v-if="productSelected" class="tag" style="font-size: 10px;">
                      {{ productSelected }}
                      <button class="remove-button" @click="productSelected = null">&times;</button>
                    </span>
                    <span v-if="bacenSelected" class="tag" style="font-size: 10px;">
                      {{ bacenSelected }}
                      <button class="remove-button" @click="bacenSelected = null">&times;</button>
                    </span>
                    <span v-if="subBacenSelected" class="tag" style="font-size: 10px;">
                      {{ subBacenSelected }}
                      <button class="remove-button" @click="subBacenSelected = null">&times;</button>
                    </span>
                  </div>
                  <div class="row__container">
                    <p class="row__type">Número Do Contrato De Crédito</p>
                    <p class="row__description">{{ c.numeroContrato ? c.numeroContrato : '-' }}</p>
                  </div>
                  <div class="row__container">
                    <p class="row__type">Valor Do Contrato</p>
                    <p class="row__description">{{ c.valorContrato || c.valorContrato === 0 ? onFormatMoney(c.valorContrato) : '-' }}</p>
                  </div>
                  <div class="row__container">
                    <p class="row__type">Valor Saldo Devedor Diário</p>
                    <p class="row__description">{{ c.vlrSaldoDevedorDiario || c.vlrSaldoDevedorDiario === 0 ? onFormatMoney(c.vlrSaldoDevedorDiario) : '-' }}</p>
                  </div>
                  <div class="row__container">
                    <p class="row__type">Modalidade Bacen</p>
                    <p class="row__description">{{ c.modalidadeBacen ? c.modalidadeBacen.toLowerCase() : '-' }}</p>
                  </div>
                  <div class="row__container">
                    <p class="row__type">Modalidade Produto</p>
                    <p class="row__description">{{ c.modalidadeProduto ? c.modalidadeProduto.toLowerCase() : '-' }}</p>
                  </div>
                  <div class="row__container">
                    <p class="row__type">Modalidade Sub Bacen</p>
                    <p class="row__description">{{ c.submodalidadeBacen ? c.submodalidadeBacen.toLowerCase() : '-' }}</p>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>

        <div>
          <b-card class="shadow-sm" no-body>
            <b-tabs class="tabsScroll" pills>
              <b-tab v-for="(c, index) in financeResume.accounts" :key="index">
                <template slot="title">{{ index + 1 }}ª</template>
                <div class="associate__info__rows__group">
                  <h3 class="associate__info__rows__group__title">Conta Corrente</h3>
                  <div class="position-tag">
                    <span v-if="productSelected" class="tag" style="font-size: 10px;">
                      {{ productSelected }}
                      <button class="remove-button" @click="productSelected = null">&times;</button>
                    </span>
                    <span v-if="bacenSelected" class="tag" style="font-size: 10px;">
                      {{ bacenSelected }}
                      <button class="remove-button" @click="bacenSelected = null">&times;</button>
                    </span>
                    <span v-if="subBacenSelected" class="tag" style="font-size: 10px;">
                      {{ subBacenSelected }}
                      <button class="remove-button" @click="subBacenSelected = null">&times;</button>
                    </span>
                  </div>

                  <div class="row__container">
                    <p class="row__type">Número da Conta Corrente</p>
                    <p class="row__description">{{ c.numeroContaCorrente ? c.numeroContaCorrente.toLowerCase() : '-' }}</p>
                  </div>
                  <div class="row__container">
                    <p class="row__type">Situação</p>
                    <p class="row__description">{{ c.situacaoContaCorrente ? c.situacaoContaCorrente.toLowerCase() : '-' }}</p>
                  </div>
                  <div class="row__container">
                    <p class="row__type">Valor Saldo Depósito</p>
                    <p class="row__description">{{ c.valorSaldoDepositoContaCorrente || c.valorSaldoDepositoContaCorrente === 0 ? onFormatMoney(c.valorSaldoDepositoContaCorrente) : '-' }}</p>
                  </div>
                  <div class="row__container">
                    <p class="row__type">Valor Saldo Bloqueio Judicial</p>
                    <p class="row__description">{{ c.valorSaldoBloqueioJudicial || c.valorSaldoBloqueioJudicial === 0 ? onFormatMoney(c.valorSaldoBloqueioJudicial) : '-' }}</p>
                  </div>
                  <div class="row__container">
                    <p class="row__type">Valor Saldo Devedor ADP</p>
                    <p class="row__description">{{ c.valorSaldoDevedorADP || c.valorSaldoDevedorADP === 0 ? onFormatMoney(c.valorSaldoDevedorADP) : '-' }}</p>
                  </div>
                  <div class="row__container">
                    <p class="row__type">Valor Saldo Devedor Limite Crédito</p>
                    <p class="row__description">{{ c.valorSaldoDevedorLimiteCredito ? onFormatMoney(c.valorSaldoDevedorLimiteCredito) : '-' }}</p>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>

        <div v-if="financeResume.ajuizamento.length">
          <div class="associate__info__rows__group">
            <h3 class="associate__info__rows__group__title">Oportunidades em Ajuizamento</h3>
            <DefaultButton
              v-for="(c, index) in financeResume.ajuizamento"
              :key="index"
              btnVariant="btn-third justify-content-center"
              :onClick="() => openCard(c.id)"
              text="Ver Card"
            />
          </div>
        </div>
      </div>
    </div>
    <tables ref="tableGrid"></tables>
  </div>
</template>

<script>
import Tools from '../../../../components/tools/Tools'
import ContaCorrenteRepository from '@/shared/http/repositories/business/contacorrente.js'
import ContratosVigentesRepository from '@/shared/http/repositories/business/contratosvigentes.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'
import CardProductRepository from '@/shared/http/repositories/crm/cardproduct.js'
import boardTypes from '@/enums/enumBoardTypes.js'

export default {
  props: {
    objSelected: {
      type: Object,
      default: () => ({})
    },
    document: { // Document prop
      type: String,
      required: true
    },
    productSelected: {
      type: String,
      default: null
    },
    bacenSelected: {
      type: String,
      default: null
    },
    subBacenSelected: {
      type: String,
      default: null
    },
    boardColumn: {
      type: Object,
      required: true
    }

  },
  data () {
    return {
      isBusyInfosFinance: true,
      productOptions: [],
      bacenOptions: [],
      subBacenOptions: [],
      financeResume: {
        contracts: [],
        accounts: [],
        cobrancaProducts: [],
        ajuizamento: []
      },
      maiorQueDezContratos: false,
      boardTypes: boardTypes
    }
  },
  watch: {
    productSelected: {
      handler (newValue) {
        this.onLoadContratosVigentesRepository(this.document, newValue)
      }
    },
    bacenSelected: {
      handler (newValue) {
        this.onLoadContratosVigentesRepository(this.document, this.productSelected, newValue)
      }
    },
    subBacenSelected: {
      handler (newValue) {
        this.onLoadContratosVigentesRepository(this.document, this.productSelected, this.bacenSelected, newValue)
      }
    }
  },
  methods: {
    async onLoadFinanceResume () {
      const document = this.document // Now comes from props

      await this.onLoadContaCorrenteRepository(document)
      await this.onLoadContratosVigentesRepository(document)
      await this.onLoadCardsFromAssociate(document)

      this.isBusyInfosFinance = !this.isBusyInfosFinance
    },
    async onLoadContaCorrenteRepository (document) {
      await ContaCorrenteRepository.Search(document, 200, 0)
        .then(response => {
          const accounts = response.data.content
          this.financeResume.accounts = accounts
        })
        .catch(err => {
          console.error(err)
        })
    },
    async onLoadContratosVigentesRepository (document, productSelected, bacenSelected, subBacenSelected) {
      try {
        const objFilter = {
          params: {
            modalidadeProduto: productSelected,
            submodalidadeBacen: subBacenSelected,
            modalidadeBacen: bacenSelected,
            document: document,
            page: 0,
            size: 200
          }
        }

        await ContratosVigentesRepository.Search(objFilter.params.document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(response => {
            const contracts = response.data.content
            const pageable = response.data.pageable
            this.financeResume.contracts = contracts
            this.maiorQueDezContratos = pageable.totalElements > 10
          })
          .catch(err => {
            console.error('Erro ao buscar contratos:', err)
          })

        await ContratosVigentesRepository.SearchByModalidadeProduto(document, 200, 0)
          .then(response => {
            this.productOptions = response.data
          })
          .catch(err => {
            console.error('Erro ao buscar contratos por modalidade de produto:', err)
          })

        await ContratosVigentesRepository.SearchBySubmodalidadeBacen(document, 200, 0)
          .then(response => {
            this.subBacenOptions = response.data
          })
          .catch(err => {
            console.error('Erro ao buscar contratos por submodalidade Bacen:', err)
          })

        await ContratosVigentesRepository.SearchByModalidadeBacen(document, 200, 0)
          .then(response => {
            this.bacenOptions = response.data
          })
      } catch (error) {
        console.error('Erro geral:', error)
      }
    },
    async onLoadCardsFromAssociate (document) {
      await CardRepository.SearchAllByDocument(document, 'situacao=ATIVO', 200, 0)
        .then(async response => {
          const cards = response.data.content
          let cardsCobranca = this.splitCardsByType(cards, this.boardTypes.COBRANCA)
          let cardsAjuizamento = this.splitCardsByType(cards, this.boardTypes.AJUIZAMENTO)

          this.financeResume.cards = {
            cobranca: cardsCobranca,
            ajuizamento: cardsAjuizamento
          }

          const cobrancaProducts = await this.getProdutosFromCobranca(cardsCobranca)

          const titulosDescontados = cobrancaProducts.filter(
            product => product.produtoDTO.nome === 'TÍTULOS DESCONTADOS'
          )

          if (titulosDescontados.length > 0) {
            const consolidatedProduct = {
              produtoDTO: { nome: 'TÍTULOS DESCONTADOS' },
              contratos: titulosDescontados.map(t => t.operacao),
              valorContrato: titulosDescontados.reduce((sum, t) => sum + (t.valor || 0), 0),
              modalidadeBacen: 'TÍTULOS DESCONTADOS'
            }

            cobrancaProducts.push(consolidatedProduct)
          }

          this.financeResume.cobrancaProducts = cobrancaProducts
        })
        .catch(err => {
          console.error(err)
        })
    },
    async getProdutosFromCobranca (cards) {
      let allProducts = []

      for (const card of cards) {
        try {
          const response = await CardProductRepository.Search(card.id, 200, 0)
          const products = response.data.content
          if (products.length) allProducts.push(...products)
        } catch (err) {
          console.error(err)
        }
      }
      return allProducts
    },
    splitCardsByType (cards, type) {
      let cardsFromType = []
      cards.forEach((card) => {
        if (card.boardColumn.board.tipoBoard === type) {
          cardsFromType.push(card)
        }
      })
      return cardsFromType
    },
    onFormatMoney (value) {
      let result = 'R$ 0,00'
      if (value) {
        result = Tools.formatMoneyBR(value)
      }
      return result
    },
    openCard (cardId) {
      this.selectedCard = cardId
    },
    closeCard () {
      this.selectedCard = null
    }
  }
}
</script>

<style scoped>
.associate__info__rows__container {
  margin: 1rem 0 2.5rem 0;
}

.associate__info__rows__group {
  margin-bottom: 1.75rem;
}

.associate__info__rows__group__title {
  font-size: 1.15rem;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 0.25rem;
}
.position-tag {
  position: relative;
  display: inline-block;
  padding-top: 8px;
}
.tag {
  display: inline-block;
  background-color: #04a791;
  color: white;
  border-radius: 4px;
  padding: 5px 10px;
  margin-right: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1;
}
.remove-button {
  background: none;
  border: none;
  color: white;
  font-size: 12px;
  cursor: pointer;
  margin-left: 5px;
}

.remove-button:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/private/associate/components/AssociateOperacoesFinanceiras.vue